import { z } from 'zod';
export const validationDecisionOutcomeSchema = z.enum(['Approved', 'Rejected']);
export const recordValidationDecisionSchema = z.object({
    outcome: validationDecisionOutcomeSchema,
});
// Rejecting has no equivalent: turning away an incomplete submission is what it is for.
export const validationApprovalBlockerSchema = z.enum([
    'ConsolidationOutstanding',
    'MissingIdentityDocument',
    'MissingCompanyAssuranceDocument',
    'MissingInsuranceExpirationDate',
    'InsuranceExpired',
    'UnpaidInstallments',
]);
const toZurichCalendarDay = (instant) => {
    const parts = new Intl.DateTimeFormat('en', {
        timeZone: 'Europe/Zurich',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(instant);
    const part = (type) => parts.find((candidate) => candidate.type === type)?.value;
    return `${part('year')}-${part('month')}-${part('day')}`;
};
export const reusesPreviousInsurance = ({ documentTypes, previousApproval, }) => previousApproval?.isInsuranceReusable === true && !documentTypes.includes('CompanyAssuranceDocument');
export const getValidationApprovalBlockers = ({ consolidationDecision, documentTypes, insuranceExpirationDate, previousApproval, hasUnpaidInstallments, }, now) => {
    const blockers = [];
    const insuranceIsReused = reusesPreviousInsurance({ documentTypes, previousApproval });
    if (consolidationDecision === 'AwaitingDecision') {
        blockers.push('ConsolidationOutstanding');
    }
    if (!documentTypes.includes('IdentityDocument') && previousApproval?.isIdentityReusable !== true) {
        blockers.push('MissingIdentityDocument');
    }
    if (!documentTypes.includes('CompanyAssuranceDocument') && !insuranceIsReused) {
        blockers.push('MissingCompanyAssuranceDocument');
    }
    if (!insuranceIsReused) {
        if (insuranceExpirationDate === null) {
            blockers.push('MissingInsuranceExpirationDate');
        }
        else if (toZurichCalendarDay(insuranceExpirationDate) <= toZurichCalendarDay(now)) {
            blockers.push('InsuranceExpired');
        }
    }
    if (hasUnpaidInstallments) {
        blockers.push('UnpaidInstallments');
    }
    return blockers;
};
